import React, { useState } from "react";
import styles from "./Calendar.module.css";
import { createArrayWithValues } from "../uitls";
import { useConfig } from "../hooks/useConfig";
import { Block } from "./Block";
import { DateOfBirthSelector } from "./DateOfBirthSelector";
import { CalendarHeader } from "./CalendarHeader";
import { useMainStore } from "../store";

// 4160 weeks < 80 years

export const AgeExpectancy = () => {
  const { yearsToLive } = useMainStore();
  const [value, setValue] = useState(yearsToLive);
  function enforceMinMax(e) {
    console.log(e);
    if (e.target.value !== "") {
      if (parseInt(e.value) < 1) {
        e.target.value = 1;
        setValue(1);
        useMainStore.setState({ yearsToLive: 1 });
        localStorage.setItem("ytl", "1");
      }
      if (parseInt(e.target.value) > 120) {
        e.target.value = 120;
        setValue(120);
        useMainStore.setState({ yearsToLive: 120 });
        localStorage.setItem("ytl", "120");
      }
    }
  }

  return (
    <div
      style={{
        display: "flex",
        // width: "100%",
        justifyContent: "center",
        marginBottom: "12px",
        gap: "3px",
      }}
    >
      <label htmlFor="expectancy">Life expectancy: </label>
      <input
        style={{ padding: "0 3px" }}
        id="expectancy"
        type="number"
        value={value}
        onChange={(e) => {
          if (parseInt(e.target.value) > 120) {
            setValue(120);
            useMainStore.setState({
              yearsToLive: 120,
            });
            localStorage.setItem("ytl", "120");
            return;
          } else if (parseInt(e.target.value) < 1) {
            setValue(1);
            useMainStore.setState({
              yearsToLive: 1,
            });
            localStorage.setItem("ytl", "1");
            return;
          }
          setValue(e.target.value);
          useMainStore.setState({
            yearsToLive: e.target.value,
          });
          localStorage.setItem("ytl", e.target.value);
        }}
        max={120}
        min={1}
        onKeyUp={enforceMinMax}
      />
    </div>
  );
};

export const Calendar = () => {
  // 2 x 8
  const { calendarSize } = useConfig();
  return (
    <div>
      <div
        style={{
          display: "flex",
          gap: "6px",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        <DateOfBirthSelector />
        <AgeExpectancy />
      </div>
      <div className={styles.calendarWrapper}>
        <CalendarHeader />
        {createArrayWithValues(calendarSize).map((n) => (
          <Block n={n} key={n} />
        ))}
      </div>
    </div>
  );
};
